"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
})(legacy_1.action('selectSenderOnTopOption')(function selectSenderOnTopOption(senderOnTop, state) {
    var optionState = state.optionState;
    optionState.showSenderOnTopInListView = senderOnTop;
}));
//# sourceMappingURL=selectSenderOnTopOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-sender-subject-option/lib/actions/selectSenderOnTopOption.js
// module id = 5126
// module chunks = 2